import React from 'react';
import { IndicatorFactorsTable } from 'app/area/indicator-factors/list/components/indicator-factors-list-table';
import { IndicatorFactorsRow } from 'app/area/indicator-factors/list/components/indicator-factors-list-row';
import { CodetableListItemsProps } from 'app/area/indicator-factors/types';
import { CodeListMeatballMenu } from 'app/area/indicator-factors/list/shared/meatball-menu';
import { getValidationForId } from 'app/area/indicator-factors/list/validation';
import { codeAccessConfiguration } from 'app/area/indicator-factors/item/codetable-item-helpers';

export const IndicatorFactorsListItems: React.FC<CodetableListItemsProps> = (props) => {
  const { codetableId, requestedSearchModel, data, numberOfResults,
    codetableAccess, itemAccesses, modifiedComments,
    fetchingData, breadcrumbs, fetchingDelete, modifiedFactors, validation,
    deleteCodeItem, loadMoreData, modifyFactor, modifyComments,
    translation, locale, metadata } = props;

  return <>
    <IndicatorFactorsTable
      data={data}
      numberOfResults={numberOfResults}
      fetchingData={fetchingData}
      loadMoreData={loadMoreData}
      requestedSearchModel={requestedSearchModel}
      metadata={metadata}
      translation={translation}>
      {(data || []).map((codeItem, index) => {

        const itemAccess = itemAccesses?.find(item => item.id === codeItem?.id);
        const codeAccess = codeAccessConfiguration(codeItem?.id, codetableAccess, itemAccess);

        const meatball = <CodeListMeatballMenu
          codetableId={codetableId}
          breadcrumbs={breadcrumbs}
          codeItem={codeItem}
          codeAccessConfiguration={codeAccess}
          deleteCodeItem={deleteCodeItem}
          translation={translation}
        />;
        const modifiedItem = modifiedFactors?.find(item => item.id === codeItem?.id);
        const modifiedComment = modifiedComments?.find(item => item.id === codeItem?.id);
        const itemValidation = getValidationForId(validation, codeItem?.id);

        const changeFactor = (factor: number) => {
          modifyFactor({ id: codeItem?.id, factor });
        };

        const changeComments = (comments: string) => {
          modifyComments({ id: codeItem?.id, comments: comments?.trim() });
        };

        return <IndicatorFactorsRow
          key={index}
          breadcrumbs={breadcrumbs}
          metadata={metadata}
          codeItem={codeItem}
          modifiedFactor={modifiedItem}
          modifiedComment={modifiedComment}
          readOnly={!codeAccess.canEdit}
          validation={itemValidation}
          fetchingDelete={fetchingDelete || codeItem.fetchingDelete}
          changeFactor={changeFactor}
          changeComments={changeComments}
          meatball={meatball}
          translation={translation}
          locale={locale}
        />;
      })}
    </IndicatorFactorsTable>
  </>;
};
